import React, { Component } from 'react';
import gql from 'graphql-tag';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import { compose, graphql } from 'react-apollo';
import { SELECTION_EVENT, trackUserEvent } from 'userActivityMiddleware';
import { SUBSCRIPTION_PREFERRED_LOCATION_CHANGED } from 'containers/DesktopNotificationTray';
import {
  CV_WEB_NEW_WSTORE_UI_ENABLED,
  LOCATION_DATA,
  SUPPORT_SOCIAL_PHONE,
  WSTORE_CHICAGO_WSTORE_AVAILABLE
} from 'utils/constants';
import { getUserData } from 'utils/graphQLFunctions';
import { CHANGE_PREFERRED_LOCATION_MUTATION } from 'utils/graphql/patronQueries';
import { QUERY_GET_REMOTE_CONFIG_ENTRY } from 'utils/hook/query/useRemoteConfigEntry';
import { errorShape, userShape } from 'utils/shapes';
import SapphireIcon from 'resources/icons-currency-sapphire-sml.png';
import WScoreIcon from 'resources/ui-icon-wscore.png';
import WStoreIcon from 'resources/FeatureIcons/Button-WStore.svg';
import { isInstantPurchase, isQuest, isQuestActive } from '../WStoreUtils';
import WStoreView from '../WStoreView';
import WStoreViewNew from '../WStoreViewNew';

const DEFAULT_LOCATION = 'Atmore';
const WSTORE_REFRESH_DELAY_MS = 100;

const ALL_CATEGORY = {
  value: 'All',
  name: 'All Item Types',
  mobileName: 'All Item Types'
};
const HOTPICKS_CATEGORY = { value: 'Hot Picks', name: 'Hot Picks' };
const DISCOVER_CATEGORY = { value: 'Discover', name: 'Discover' };

const ITEM_DELETED_MSG = 'This item has been removed from the WStore';
const GENERIC_ERROR_MSG =
  'An error has occurred, please try again. If the problem persists, please chat with us or call us at ' +
  SUPPORT_SOCIAL_PHONE;
const WSCORE_LOW_MSG = 'You do not have enough WScore';
const NUGGETS_LOW_MSG = 'You do not have enough Nuggets';
const RUBIES_LOW_MSG = 'You do not have enough Rubies';
const SAPPHIRES_LOW_MSG = 'You do not have enough Sapphires';
const WCHIPS_LOW_MSG = 'You do not have enough WChips';

const SOLD_OUT_MSG = 'This WStore item is Sold Out';
const LIMIT_REACHED_MSG = 'Your purchase limit has been reached';
const CONFIRMATION_INSTANT_MSG =
  'A confirmation email has been sent and your purchase is being added to your account.';
const CONFIRMATION_IHUB_MSG =
  'A confirmation email has been sent. Please allow up to 30 minutes for your WStore item to become available on your Player Rewards Card.';

const NEW_UI_ALERT_MESSAGES = {
  lowWScore: {
    title: "You don't have enough WScore to purchase this.",
    body: 'Keep playing to earn WScore and unlock this reward!',
    icon: WScoreIcon
  },
  lowSapphires: {
    title: "You don't have enough Sapphires to purchase this.",
    body: 'Keep playing to earn Sapphires and unlock this reward!',
    icon: SapphireIcon
  },
  soldOut: {
    title: 'This item is sold out.',
    body: 'Keep an eye out for new arrivals',
    icon: WStoreIcon
  },
  limitReached: {
    title: 'Your purchase limit has been reached.',
    body: 'Please wait until tomorrow to make another purchase',
    icon: WStoreIcon
  },
  generic: {
    title: 'An error has occurred, please try again.',
    body:
      'If the problem persists, please chat with us or call us at ' +
      SUPPORT_SOCIAL_PHONE,
    icon: WStoreIcon
  },
  itemDeleted: {
    title: 'This item has been removed from the WStore.',
    body: '',
    icon: WStoreIcon
  }
};

class WStoreContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedItem: null,
      purchaseRequested: false,
      purchaseResponseMsg: '',
      purchaseEmailMsg: '',
      purchaseConfirmation: false,
      purchaseError: false,
      alertMsg: '',
      showCategoryFilterOptions: false,
      categoryFilter: ALL_CATEGORY,
      showWStorePreferenceModal: false,
      editingWStorePreference: false,
      showBattleSlotsInventory: false,
      showWStoreCategories: false,
      purchaseWithTrade: false,
      wstorePropertyUpdateNotifications: [],
      showDiscover: true
    };

    this.handleSelectItem = this.handleSelectItem.bind(this);
    this.handleOpenWStoreCategories =
      this.handleOpenWStoreCategories.bind(this);
    this.handleOnCloseWStoreCategories =
      this.handleOnCloseWStoreCategories.bind(this);
    this.handleSelectMyInventory = this.handleSelectMyInventory.bind(this);
    this.handleSelectHotPicks = this.handleSelectHotPicks.bind(this);
    this.handleSelectAllCategory = this.handleSelectAllCategory.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlePurchase = this.handlePurchase.bind(this);
    this.handleSelectCategory = this.handleSelectCategory.bind(this);
    this.handleShowCategoryFilterOptions =
      this.handleShowCategoryFilterOptions.bind(this);
    this.handleSelectLocation = this.handleSelectLocation.bind(this);
    this.onWStoreResetNotificationUpdate =
      this.onWStoreResetNotificationUpdate.bind(this);
    this.handleOnEditLocationPreference =
      this.handleOnEditLocationPreference.bind(this);
    this.handleOnCloseSelectPreference =
      this.handleOnCloseSelectPreference.bind(this);
    this.handleOnCloseBattleSlotsInventory =
      this.handleOnCloseBattleSlotsInventory.bind(this);
    this.handleSelectItemWithTrade = this.handleSelectItemWithTrade.bind(this);
    this.handleSelectDiscover = this.handleSelectDiscover.bind(this);

    this.unsubscribeFromNewData = () => {};
    this.unsubscribeToWScoreData = () => {};
    this.unsubscribeToWStoreUserDataUpdate = () => {};
    this.unsubscribeToPurchaseLeftDataUpdate = () => {};
    this.unsubscribeToWStoreResetNotificationReloadDataUpdate = () => {};
    this.unsubscribeToWStoreAdminUpdateNotificationReloadDataUpdate = () => {};
    this.unsubscribeToWStorePropertyUpdateNotificationReloadDataUpdate =
      () => {};
    this.unsubscribeFromLocationData = () => {};

    this.changeLocationTimeout = null;
  }

  componentDidMount() {
    this.unsubscribeFromNewData = this.props.subscribeToNewData();
    this.unsubscribeToWScoreData = this.props.subscribeToWScoreData();
    this.unsubscribeToWStoreUserDataUpdate =
      this.props.subscribeToWStoreUserDataUpdate();
    this.unsubscribeToPurchaseLeftDataUpdate =
      this.props.subscribeToPurchaseLeftDataUpdate();
    this.unsubscribeFromBattleFromBattleSlotsInventoryUpdate =
      this.props.subscribeToBattleSlotsInventoryUpdates();
    this.unsubscribeToWStoreResetNotificationDataUpdate =
      this.props.subscribeToWStoreResetNotificationDataUpdate(
        this.onWStoreResetNotificationUpdate
      );
    this.unsubscribeToWStoreAdminUpdateNotificationReloadDataUpdate =
      this.props.subscribeToWStoreAdminUpdateNotificationReloadDataUpdate(
        this.onWStoreResetNotificationUpdate
      );
    this.unsubscribeToWStorePropertyUpdateNotificationReloadDataUpdate =
      this.props.subscribeToWStorePropertyUpdateNotificationReloadDataUpdate();
    this.unsubscribeFromLocationData = this.props.subscribeToLocationData();

    this.detectDefaultCategory();
  }

  componentWillUnmount() {
    this.unsubscribeFromNewData();
    this.unsubscribeFromNewData = () => {};
    this.unsubscribeToWScoreData();
    this.unsubscribeToWScoreData = () => {};
    this.unsubscribeToWStoreUserDataUpdate();
    this.unsubscribeToWStoreUserDataUpdate = () => {};
    this.unsubscribeToPurchaseLeftDataUpdate();
    this.unsubscribeToPurchaseLeftDataUpdate = () => {};
    this.unsubscribeToWStoreResetNotificationDataUpdate();
    this.unsubscribeToWStoreResetNotificationDataUpdate = () => {};
    this.unsubscribeToWStoreAdminUpdateNotificationReloadDataUpdate();
    this.unsubscribeToWStoreAdminUpdateNotificationReloadDataUpdate = () => {};
    this.unsubscribeToWStorePropertyUpdateNotificationReloadDataUpdate();
    this.unsubscribeToWStorePropertyUpdateNotificationReloadDataUpdate =
      () => {};
    this.unsubscribeFromBattleFromBattleSlotsInventoryUpdate();
    this.unsubscribeFromBattleFromBattleSlotsInventoryUpdate = () => {};
    this.unsubscribeFromLocationData = () => {};

    clearTimeout(this.changeLocationTimeout);
  }

  shouldSetConfiguration(props) {
    return (
      props &&
      props.wstoreConfigurationData &&
      !props.wstoreConfigurationData.loading
    );
  }

  componentDidUpdate(prevProps) {
    if (
      this.shouldSetConfiguration(this.props) &&
      !this.shouldSetConfiguration(prevProps)
    ) {
      if (
        this.props.wstoreConfigurationData.getWStoreConfiguration &&
        this.props.wstoreConfigurationData.getWStoreConfiguration.enabled ===
          false
      ) {
        this.handleClose();
      }
    } else {
      const { getWStoreConfiguration: newData } =
        this.props.wstoreConfigurationData;
      const { getWStoreConfiguration: OldData } =
        prevProps.wstoreConfigurationData;

      if (OldData && newData) {
        if (OldData.enabled !== newData.enabled) {
          this.handleClose();
        }
      }
    }

    if (this.state.selectedItem && isQuest(this.state.selectedItem)) {
      let prevItem = prevProps.wstoreItemsData.getWStoreData.items.find(
        item => item.itemId === this.state.selectedItem.itemId
      );
      let newItem = this.props.wstoreItemsData.getWStoreData.items.find(
        item => item.itemId === this.state.selectedItem.itemId
      );

      // purchase not requested, so this idle on quest details.  if quest turns to active, limit was reached
      if (
        !this.state.purchaseRequested &&
        isQuestActive(newItem) &&
        !isQuestActive(prevItem)
      ) {
        this.setState({
          alertMsg: LIMIT_REACHED_MSG,
          selectedItem: null
        });
      }
    }

    if (
      !prevProps.prizeCategoriesData.getPrizeCategories &&
      this.props.prizeCategoriesData.getPrizeCategories
    ) {
      this.detectDefaultCategory();
    }

    if (
      !prevProps.newWStoreEnabledData.remoteConfigEntry &&
      this.props.newWStoreEnabledData.remoteConfigEntry &&
      !this.props.newWStoreEnabledData.remoteConfigEntry.value
    ) {
      this.setState({
        showWStoreCategories: true,
        showDiscover: false
      });
    }
  }

  detectDefaultCategory() {
    const prizeCategories =
      this.props.prizeCategoriesData.getPrizeCategories &&
      this.props.prizeCategoriesData.getPrizeCategories.prizeCategories;
    const categoryValue =
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.categoryValue;
    if (prizeCategories && categoryValue) {
      const category = prizeCategories.find(c => c.value === categoryValue);
      if (category) {
        this.handleSelectCategory(category);
        this.handleOnCloseWStoreCategories();
      }
    }
  }

  handleOnEditLocationPreference() {
    this.setState({
      showWStorePreferenceModal: true
    });

    trackUserEvent({
      activityType: SELECTION_EVENT,
      eventName: 'open-location-preference-modal',
      initiator: 'change-location',
      eventParams: {
        property: this.getUserPreferredLocation(this.props.userData.user)
      }
    });
  }

  handleSelectLocation(location) {
    if (location) {
      if (location !== 'All') {
        this.setState({
          editingWStorePreference: true
        });
        this.props.changePreferredLocation(location).then(resp => {
          if (this.onWStoreResetNotificationUpdate) {
            clearTimeout(this.changeLocationTimeout);
            this.changeLocationTimeout = setTimeout(() => {
              this.onWStoreResetNotificationUpdate();
              this.handleOpenWStoreCategories();
            }, WSTORE_REFRESH_DELAY_MS);
          }
        });
      }
    }
  }

  handleOnCloseSelectPreference() {
    this.setState({
      showWStorePreferenceModal: false,
      editingWStorePreference: false
    });
  }

  handleOpenWStoreCategories() {
    this.setState({ showWStoreCategories: true });
  }

  handleOnCloseWStoreCategories() {
    this.setState({ showWStoreCategories: false });
  }

  handleSelectMyInventory() {
    this.setState({ showBattleSlotsInventory: true });
  }

  handleOnCloseBattleSlotsInventory() {
    this.setState({ showBattleSlotsInventory: false });
  }

  handleSelectAllCategory() {
    this.setState({
      categoryFilter: ALL_CATEGORY,
      showDiscover: false
    });
  }

  handleSelectHotPicks() {
    this.setState({
      categoryFilter: HOTPICKS_CATEGORY,
      showWStoreCategories: false,
      showDiscover: false
    });
  }

  handleSelectDiscover() {
    this.setState({
      categoryFilter: ALL_CATEGORY,
      showDiscover: true
    });
  }

  areHotPicksAvailable(items) {
    return items && items.some(item => item.hotPick);
  }

  getRewardCategories(
    items,
    getPrizeCategories,
    disabledCategories,
    hotPicksAvailable
  ) {
    const enableDiscover =
      !!this.props.newWStoreEnabledData.remoteConfigEntry?.value;
    let newCategories = [];
    items.forEach(item => {
      if (
        !newCategories.some(c => c.value === item.classCode) &&
        !disabledCategories.includes(item.classCode)
      ) {
        const category = getPrizeCategories.prizeCategories.find(
          c => c.value === item.classCode
        );
        if (category) {
          newCategories.push({ value: category.value, name: category.name });
        }
      }
    });
    if (hotPicksAvailable) {
      newCategories.push(HOTPICKS_CATEGORY);
    }
    newCategories.sort(function (a, b) {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      if (nameA < nameB) return -1;
      else if (nameA > nameB) return 1;
      else return 0;
    });
    newCategories.unshift(ALL_CATEGORY);
    enableDiscover && newCategories.unshift(DISCOVER_CATEGORY);
    return newCategories;
  }

  onWStoreResetNotificationUpdate() {
    const enableDiscover =
      !!this.props.newWStoreEnabledData.remoteConfigEntry?.value;

    this.props.wstoreItemsData
      .refetch()
      .then(resp => {
        if (
          this.state.categoryFilter === HOTPICKS_CATEGORY &&
          !this.areHotPicksAvailable(resp.data.getWStoreData.items)
        ) {
          this.setState({ categoryFilter: ALL_CATEGORY });
        }

        if (this.state.selectedItem) {
          let wstoreItem = resp.data.getWStoreData.items.find(
            item => item.itemId === this.state.selectedItem.itemId
          );
          if (wstoreItem) {
            this.setState({ selectedItem: wstoreItem });
          } else {
            this.setState({
              selectedItem: null,
              alertMsg: enableDiscover
                ? NEW_UI_ALERT_MESSAGES.itemDeleted
                : ITEM_DELETED_MSG
            });
          }
        }
      })
      .catch(() => {
        if (this.state.selectedItem) {
          this.setState({
            selectedItem: null,
            alertMsg: enableDiscover
              ? NEW_UI_ALERT_MESSAGES.generic
              : GENERIC_ERROR_MSG
          });
        }
      });
  }

  handleClose() {
    const { selectedItem } = this.state;

    if (selectedItem) {
      trackUserEvent({
        activityType: SELECTION_EVENT,
        eventName: 'close-view-item',
        eventValue: selectedItem.itemId,
        initiator: 'item-modal-close-button',
        eventParams: {
          property: this.getUserPreferredLocation(this.props.userData.user),
          filter: this.state.categoryFilter && this.state.categoryFilter.name,
          itemName: selectedItem.name
        }
      });
    }

    this.setState({
      selectedItem: null,
      purchaseRequested: false,
      purchaseResponseMsg: '',
      purchaseEmailMsg: '',
      purchaseConfirmation: false,
      alertMsg: ''
    });
  }

  // if currencyItemsPurchased is not null, this purchase includes a trade (wscore for gems)
  handlePurchase(event, currencyItemsPurchased = null) {
    event.preventDefault();
    const item = this.state.selectedItem;
    const instant = isInstantPurchase(item, this.state.categoryFilter);
    if (
      !item.wstoreItemCount.unlimitedInventory &&
      item.wstoreItemCount.availableCount <= 0
    ) {
      this.setState({
        purchaseEmailMsg: '',
        purchaseResponseMsg: 'Sorry! ' + SOLD_OUT_MSG
      });
    } else {
      const { exchangeRatesData } = this.props;
      const {
        wscorePerNugget,
        wscorePerRuby,
        wscorePerSapphire,
        wscorePerWChip
      } = exchangeRatesData.getExchangeRates;

      const enableDiscover =
        !!this.props.newWStoreEnabledData.remoteConfigEntry?.value;

      this.setState({
        purchaseRequested: true
      });
      const exchange =
        currencyItemsPurchased !== null
          ? {
              currencyItemsPurchased,
              exchangeRates: {
                wscorePerNugget,
                wscorePerRuby,
                wscorePerSapphire,
                wscorePerWChip
              }
            }
          : null;

      this.props
        .makeWstoreItemPurchase(item, exchange)
        .then(resp => {
          let newState = {
            purchaseRequested: false,
            purchaseEmailMsg: '',
            purchaseResponseMsg: '',
            purchaseConfirmation: true,
            purchaseError: false
          };

          const eventTrackPayload = {
            activityType: SELECTION_EVENT,
            eventValue: item.itemId,
            initiator: 'item-modal-redeem-button',
            eventParams: {
              property: this.getUserPreferredLocation(this.props.userData.user),
              filter:
                this.state.categoryFilter && this.state.categoryFilter.name,
              itemName: item.name
            }
          };

          if (resp?.data?.wstoreItemPurchase?.success) {
            newState.purchaseResponseMsg = resp.data.wstoreItemPurchase.message;

            if (resp.data.wstoreItemPurchase.success) {
              newState.purchaseEmailMsg = instant
                ? CONFIRMATION_INSTANT_MSG
                : CONFIRMATION_IHUB_MSG;

              trackUserEvent({
                ...eventTrackPayload,
                eventName: 'purchase-item-success'
              });
            }
          } else {
            newState.purchaseResponseMsg = enableDiscover
              ? NEW_UI_ALERT_MESSAGES.generic
              : resp.data.wstoreItemPurchase.message ||
                'Sorry! ' + GENERIC_ERROR_MSG;

            newState.purchaseError = true;

            trackUserEvent({
              ...eventTrackPayload,
              eventName: 'purchase-item-failure'
            });
          }

          this.setState(newState);
        })
        .catch(() => {
          this.setState({
            purchaseRequested: false,
            purchaseEmailMsg: '',
            purchaseResponseMsg: enableDiscover
              ? NEW_UI_ALERT_MESSAGES.generic
              : 'Sorry! ' + GENERIC_ERROR_MSG,
            purchaseConfirmation: true,
            purchaseError: true
          });
        });
    }
  }

  handleSelectItem(item, viewOnly = false) {
    const enableDiscover =
      !!this.props.newWStoreEnabledData.remoteConfigEntry?.value;

    const userWScore = this.props.wscoreData.patronAssets.wscore;
    const userNuggets = this.props.wscoreData.patronAssets.nuggets;
    const userRubies = this.props.wscoreData.patronAssets.rubies;
    const userSapphires = this.props.wscoreData.patronAssets.sapphires;
    const userWchips = this.props.wscoreData.patronAssets.wchips;

    const gemsLowMsgs = [];
    let discoverGemsLowMsg = '';

    if (!enableDiscover) {
      if (item.wscore > userWScore) {
        gemsLowMsgs.push(WSCORE_LOW_MSG);
      }
      if (item.nuggetCost && item.nuggetCost > userNuggets) {
        gemsLowMsgs.push(NUGGETS_LOW_MSG);
      }
      if (item.rubyCost && item.rubyCost > userRubies) {
        gemsLowMsgs.push(RUBIES_LOW_MSG);
      }
      if (item.sapphireCost && item.sapphireCost > userSapphires) {
        gemsLowMsgs.push(SAPPHIRES_LOW_MSG);
      }
      if (item.wchipCost && item.wchipCost > userWchips) {
        gemsLowMsgs.push(WCHIPS_LOW_MSG);
      }
    } else if (!viewOnly) {
      if (item.wscore && item.wscore > userWScore) {
        discoverGemsLowMsg = NEW_UI_ALERT_MESSAGES.lowWScore;
      }
      if (item.sapphireCost && item.sapphireCost > userSapphires) {
        discoverGemsLowMsg = NEW_UI_ALERT_MESSAGES.lowSapphires;
      }
    }

    if (gemsLowMsgs.length > 0) {
      this.setState({
        alertMsg: gemsLowMsgs.map((msg, index) => <div key={index}>{msg}</div>),
        selectedItem: item
      });
    } else if (discoverGemsLowMsg) {
      this.setState({
        alertMsg: discoverGemsLowMsg,
        selectedItem: item
      });
    } else if (
      !item.wstoreItemCount.unlimitedInventory &&
      item.wstoreItemCount.availableCount <= 0
    ) {
      this.setState({
        alertMsg: enableDiscover ? NEW_UI_ALERT_MESSAGES.soldOut : SOLD_OUT_MSG,
        selectedItem: item
      });
    } else if (
      item.wstoreItemCount.purchaseType !== 'Unlimited' &&
      item.wstoreItemCount.purchaseLeft <= 0
    ) {
      this.setState({
        alertMsg: enableDiscover
          ? NEW_UI_ALERT_MESSAGES.limitReached
          : LIMIT_REACHED_MSG,
        selectedItem: item
      });
    } else {
      this.setState({
        selectedItem: item,
        purchaseRequested: false,
        purchaseResponseMsg: '',
        purchaseWithTrade: false
      });

      trackUserEvent({
        activityType: SELECTION_EVENT,
        eventName: 'view-item',
        eventValue: item.itemId,
        initiator: 'view-item-button',
        eventParams: {
          property: this.getUserPreferredLocation(this.props.userData.user),
          filter: this.state.categoryFilter && this.state.categoryFilter.name,
          itemName: item.name
        }
      });
    }
  }

  handleSelectItemWithTrade(item) {
    this.setState({
      selectedItem: item,
      purchaseWithTrade: true
    });

    trackUserEvent({
      activityType: SELECTION_EVENT,
      eventName: 'view-item',
      eventValue: item.itemId,
      initiator: 'view-item-button',
      eventParams: {
        property: this.getUserPreferredLocation(this.props.userData.user),
        filter: this.state.categoryFilter && this.state.categoryFilter.name,
        itemName: item.name,
        trade: true
      }
    });
  }

  handleSelectCategory(category, fromFilterMenu = false) {
    this.setState({
      categoryFilter: category,
      showDiscover: false
    });

    if (fromFilterMenu) {
      this.handleShowCategoryFilterOptions();
    }
  }

  handleShowCategoryFilterOptions() {
    this.setState(prevState => ({
      showCategoryFilterOptions: !prevState.showCategoryFilterOptions
    }));
  }

  getUserPreferredLocation(user) {
    if (
      user &&
      user.preferredLocation &&
      !!LOCATION_DATA[user.preferredLocation]
    ) {
      return user.preferredLocation;
    } else {
      return null;
    }
  }

  getLocationItems(preferredLocation) {
    const { wstoreItemsData } = this.props;
    const location = preferredLocation || DEFAULT_LOCATION;
    return wstoreItemsData.getWStoreData.items.filter(
      item =>
        item.locations.length === 0 ||
        item.locations.find(loc => loc === location || loc === 'All')
    );
  }

  filterItemsByCategory(items, disabledCategories) {
    const category = this.state.categoryFilter;
    if (disabledCategories && disabledCategories.length) {
      items = items.filter(
        item => !disabledCategories.includes(item.classCode)
      );
    }
    if (category === ALL_CATEGORY) {
      return items;
    } else if (category === HOTPICKS_CATEGORY) {
      return items.filter(item => item.hotPick);
    } else {
      return items.filter(item => item.classCode === category.value);
    }
  }

  render() {
    const {
      userData,
      wstoreItemsData,
      wscoreData,
      prizeCategoriesData,
      wstoreConfigurationData,
      wstorePropertySettingsData,
      battleSlotsSupportedPropertiesData,
      battleSlotsInventoryData,
      battleSlotsInformationMarkdownTextData,
      exchangeRatesData,
      partnersCategoryEnabledData,
      ...otherProps
    } = this.props;

    const {
      selectedItem,
      purchaseWithTrade,
      purchaseRequested,
      purchaseResponseMsg,
      purchaseEmailMsg,
      purchaseConfirmation,
      purchaseError,
      alertMsg,
      categoryFilter,
      showCategoryFilterOptions,
      showWStorePreferenceModal,
      editingWStorePreference,
      showBattleSlotsInventory,
      showWStoreCategories,
      showDiscover
    } = this.state;

    const loading =
      userData.loading ||
      wstoreItemsData.loading ||
      wscoreData.loading ||
      prizeCategoriesData.loading ||
      battleSlotsSupportedPropertiesData.loading ||
      battleSlotsInventoryData.loading ||
      battleSlotsInformationMarkdownTextData.loading ||
      exchangeRatesData.loading ||
      wstoreConfigurationData.loading;
    const error =
      userData.error ||
      wstoreItemsData.error ||
      wscoreData.error ||
      prizeCategoriesData.error ||
      battleSlotsSupportedPropertiesData.error ||
      battleSlotsInventoryData.error ||
      battleSlotsInformationMarkdownTextData.error ||
      exchangeRatesData.error ||
      wstoreConfigurationData.error;
    const ready = !loading && !error;

    const wstoreData = wstoreItemsData.getWStoreData;
    const categoriesData = prizeCategoriesData.getPrizeCategories;
    const wstoreConfiguration = wstoreConfigurationData.getWStoreConfiguration;
    const patronAssets = wscoreData.patronAssets;

    const disabledCategories = [];

    const wstoreEnabled = wstoreConfiguration && wstoreConfiguration.enabled;
    const wstoreReloadDate = wstoreData && wstoreData.wstoreReloadDate;
    const preferredLocation = this.getUserPreferredLocation(userData.user);
    const locationItems =
      ready && !editingWStorePreference
        ? this.getLocationItems(preferredLocation)
        : [];
    const showHotPicks = ready && this.areHotPicksAvailable(locationItems);
    const categories = ready
      ? this.getRewardCategories(
          locationItems,
          categoriesData,
          disabledCategories,
          showHotPicks
        )
      : [];
    const items = this.filterItemsByCategory(locationItems, disabledCategories);
    const userWScore = patronAssets && patronAssets.wscore;

    const battleSlotsSupportedProperties = ready
      ? battleSlotsSupportedPropertiesData.battleSlotsSupportedProperties
          .supportedProperties
      : [];
    const battleSlotsInventory = ready
      ? battleSlotsInventoryData.getBattleSlotsInventory
      : [];
    const battleSlotsInfoText = ready
      ? battleSlotsInformationMarkdownTextData.battleSlotsInfoAsMarkdown
          .battleSlotsInfo
      : '';

    const exchangeRates = ready ? exchangeRatesData.getExchangeRates : null;
    let wstorePropertySettings = wstorePropertySettingsData.loading
      ? []
      : wstorePropertySettingsData.getWStorePropertySettings
          .wstorePropertySettings;

    const enableDiscover =
      !!this.props.newWStoreEnabledData.remoteConfigEntry?.value;
    const ViewComponent = enableDiscover ? WStoreViewNew : WStoreView;

    return (
      <ViewComponent
        loading={loading}
        error={error}
        wstoreEnabled={wstoreEnabled}
        propertyEnabledWStore={wstorePropertySettings}
        wstoreReloadDate={wstoreReloadDate}
        userWScore={userWScore}
        patronAssets={patronAssets}
        preferredLocation={preferredLocation}
        items={items}
        battleSlotsSupportedProperties={battleSlotsSupportedProperties}
        battleSlotsInventory={battleSlotsInventory}
        battleSlotsInfoText={battleSlotsInfoText}
        categories={categories}
        showHotPicks={showHotPicks}
        selectedItem={selectedItem}
        purchaseWithTrade={purchaseWithTrade}
        purchaseRequested={purchaseRequested}
        purchaseResponseMsg={purchaseResponseMsg}
        purchaseEmailMsg={purchaseEmailMsg}
        purchaseConfirmation={purchaseConfirmation}
        purchaseError={purchaseError}
        alertMsg={alertMsg}
        categoryFilter={categoryFilter}
        showCategoryFilterOptions={showCategoryFilterOptions}
        showWStorePreferenceModal={
          userData.user && !preferredLocation ? true : showWStorePreferenceModal
        }
        user={userData.user}
        editingWStorePreference={editingWStorePreference}
        showBattleSlotsInventory={showBattleSlotsInventory}
        showWStoreCategories={showWStoreCategories}
        showDiscover={showDiscover}
        enableDiscover={enableDiscover}
        onSelectDiscover={this.handleSelectDiscover}
        onSelectItem={this.handleSelectItem}
        onSelectItemWithTrade={this.handleSelectItemWithTrade}
        onOpenWStoreCategories={this.handleOpenWStoreCategories}
        onCloseWStoreCategories={this.handleOnCloseWStoreCategories}
        onSelectMyInventory={this.handleSelectMyInventory}
        onSelectHotPicks={this.handleSelectHotPicks}
        onSelectAllCategory={this.handleSelectAllCategory}
        onSelectCategory={this.handleSelectCategory}
        onShowCategoryFilterOptions={this.handleShowCategoryFilterOptions}
        onSelectLocation={this.handleSelectLocation}
        onPurchase={this.handlePurchase}
        onClose={this.handleClose}
        onEditLocationPreference={this.handleOnEditLocationPreference}
        onCloseSelectPreference={this.handleOnCloseSelectPreference}
        onCloseBattleSlotsInventory={this.handleOnCloseBattleSlotsInventory}
        exchangeRates={exchangeRates}
        {...otherProps}
      />
    );
  }
}

WStoreContainer.propTypes = {
  userData: PropTypes.shape({
    user: userShape,
    loading: PropTypes.bool,
    error: errorShape
  }),
  wstoreItemsData: PropTypes.shape({
    getWStoreData: PropTypes.shape({
      wstoreReloadDate: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.object)
    }),
    loading: PropTypes.bool,
    error: errorShape
  }),
  wscoreData: PropTypes.shape({
    patronAssets: PropTypes.shape({
      wscore: PropTypes.number,
      nuggets: PropTypes.number,
      rubies: PropTypes.number,
      sapphires: PropTypes.number,
      wchips: PropTypes.number
    }),
    loading: PropTypes.bool,
    error: errorShape
  }),
  prizeCategoriesData: PropTypes.shape({
    getPrizeCategories: PropTypes.shape({
      prizeCategories: PropTypes.arrayOf(PropTypes.object)
    }),
    loading: PropTypes.bool,
    error: errorShape
  }),
  wstoreConfigurationData: PropTypes.shape({
    getWStoreConfiguration: PropTypes.object,
    loading: PropTypes.bool,
    error: errorShape
  }),
  wstorePropertySettingsData: PropTypes.shape({
    getWStorePropertySettings: PropTypes.shape({
      wstorePropertySettings: PropTypes.arrayOf(PropTypes.object)
    }),
    loading: PropTypes.bool,
    error: errorShape
  }),
  subscribeToNewData: PropTypes.func,
  subscribeToPurchaseLeftDataUpdate: PropTypes.func,
  subscribeToWStoreUserDataUpdate: PropTypes.func,
  subscribeToWStoreResetNotificationDataUpdate: PropTypes.func,
  subscribeToWStoreAdminUpdateNotificationReloadDataUpdate: PropTypes.func,
  subscribeToWStorePropertyUpdateNotificationReloadDataUpdate: PropTypes.func
};

const MUTATION_MAKE_WSTORE_PURCHASE = gql`
  mutation wstoreItemPurchase($input: WStoreItemPurchaseInput!) {
    wstoreItemPurchase(input: $input) {
      success
      message
      purchaseLeft
    }
  }
`;

const QUERY_GET_WSTORE_CONFIGURATION = gql`
  query getWStoreConfiguration {
    getWStoreConfiguration {
      enabled
    }
  }
`;

const QUERY_GET_WSTORE_PROPERTY_SETTINGS = gql`
  query getWStorePropertySettings {
    getWStorePropertySettings {
      wstorePropertySettings {
        property
        wstoreEnabled
        cvWStoreEnabled
      }
    }
  }
`;

const QUERY_GET_WSTORE_ITEMS = gql`
  query getWStoreData {
    getWStoreData {
      wstoreReloadDate
      items {
        itemId
        prizeData {
          id
          questAwardData {
            userId
            isActive
            awardCount
            quest {
              id
              maxAwards
              achievements {
                id
                description
                icons {
                  url
                  alt
                }
                progressPlaceholderText
              }
              prizeDetails {
                name
                url
                description
              }
              prizes {
                prizes {
                  id
                  name
                  category
                }
              }
              leaderboardEnabled
              leaderboardDescription
            }
          }
        }
        classCode
        subCategory
        name
        description
        termsAndConditions
        location
        locations
        wstoreItemCount {
          unlimitedInventory
          purchaseType
          purchaseLeft
          availableCount
        }
        wscore
        nuggetCost
        sapphireCost
        rubyCost
        wchipCost
        imageUrl
        claimStartDate
        claimEndDate
        hotPick
        exchangeAvailable
      }
    }
  }
`;

const SUBSCRIPTION_PURCHASE_UPDATES = gql`
  subscription wstorePurchaseUpdate {
    wstorePurchaseUpdate {
      itemId
      availableCount
    }
  }
`;

const SUBSCRIPTION_PURCHASE_LEFT_UPDATES = gql`
  subscription purchaseLeftUpdate {
    purchaseLeftUpdate {
      itemId
      purchaseLeft
    }
  }
`;

const SUBSCRIPTION_WSTOREUSERDATA_UPDATES = gql`
  subscription wstoreUserDataUpdate {
    wstoreUserDataUpdate {
      items {
        itemId
        classCode
        name
        description
        location
        locations
        wstoreItemCount {
          unlimitedInventory
          purchaseType
          purchaseLeft
          availableCount
        }
        wscore
        nuggetCost
        sapphireCost
        rubyCost
        wchipCost
        imageUrl
        claimStartDate
        claimEndDate
        hotPick
        prizeData {
          id
          questAwardData {
            userId
            isActive
            awardCount
          }
        }
      }
    }
  }
`;

const WSCORE_QUERY = gql`
  query {
    patronAssets {
      wscore
      nuggets
      rubies
      sapphires
      wchips
    }
  }
`;

const QUERY_GET_PRIZE_CATEGORIES = gql`
  query getPrizeCategories {
    getPrizeCategories {
      prizeCategories {
        name
        value
      }
    }
  }
`;

const QUERY_GET_BATTLESLOTS_SUPPORTED_PROPERTIES = gql`
  query {
    battleSlotsSupportedProperties {
      supportedProperties
    }
  }
`;

const QUERY_GET_BATTLESLOTS_INVENTORY = gql`
  query {
    getBattleSlotsInventory {
      subCategory
      count
    }
  }
`;

const QUERY_GET_BATTLESLOTS_INFORMATION_AS_MARKDOWN = gql`
  query {
    battleSlotsInfoAsMarkdown {
      battleSlotsInfo
    }
  }
`;

const QUERY_GET_EXCHANGE_RATES = gql`
  query {
    getExchangeRates {
      wscorePerNugget
      wscorePerSapphire
      wscorePerRuby
      wscorePerWChip
    }
  }
`;

const SUBSCRIPTION_BATTLE_SLOTS_INVENTORY_UPDATES = gql`
  subscription {
    battleSlotsInventoryCollectionUpdates {
      battleSlotsInventoryCollection {
        inventories {
          subCategory
          count
        }
      }
    }
  }
`;

const SUBSCRIPTION_UPDATED_CURRENCY_ITEM_BALANCES = gql`
  subscription {
    updatedCurrencyItemBalances {
      wscoreBalance
      nuggetsBalance
      sapphiresBalance
      rubiesBalance
      wchipsBalance
    }
  }
`;

const SUBSCRIPTION_WSTORE_RESET_NOTIFICATION = gql`
  subscription {
    wstoreResetNotification {
      reset
    }
  }
`;

const SUBSCRIPTION_WSTORE_ADMIN_UPDATE_NOTIFICATION = gql`
  subscription {
    wstoreAdminUpdateNotification {
      reloadSettings
      enabledWStore
    }
  }
`;

const SUBSCRIPTION_WSTORE_PROPERTY_UPDATE_NOTIFICATIONS = gql`
  subscription {
    wstorePropertyUpdateNotifications {
      wstorePropertySettings {
        property
        wstoreEnabled
        cvWStoreEnabled
      }
    }
  }
`;

const REMOTE_CONFIG_EVENT = gql`
  subscription remoteConfigEvent {
    remoteConfigEvent {
      action
      entries {
        key
        value
      }
    }
  }
`;

export default compose(
  getUserData({
    name: 'userData',
    props: ({ userData }) => {
      return {
        userData,
        subscribeToLocationData: () => {
          return userData.subscribeToMore({
            document: SUBSCRIPTION_PREFERRED_LOCATION_CHANGED,
            updateQuery: (prev, { subscriptionData }) => {
              if (
                !!subscriptionData?.data?.newPreferredLocation &&
                subscriptionData.data.newPreferredLocation !==
                  prev?.user?.preferredLocation
              ) {
                prev.user.preferredLocation =
                  subscriptionData.data.newPreferredLocation;
              }
              return prev;
            }
          });
        }
      };
    }
  }),
  graphql(WSCORE_QUERY, {
    name: 'wscoreData',
    options: { fetchPolicy: 'cache-and-network' },
    props: ({ ownProps, wscoreData }) => ({
      wscoreData,
      subscribeToWScoreData: () => {
        return wscoreData.subscribeToMore({
          document: SUBSCRIPTION_UPDATED_CURRENCY_ITEM_BALANCES,
          updateQuery: (prev, { subscriptionData }) => {
            const {
              wscoreBalance,
              nuggetsBalance,
              sapphiresBalance,
              rubiesBalance,
              wchipsBalance
            } = subscriptionData.data;

            let currencyItemBalances = {};
            if (!isNil(wscoreBalance)) {
              currencyItemBalances.wscore = wscoreBalance;
            } else {
              currencyItemBalances.wscore = prev.patronAssets.wscore;
            }
            if (!isNil(nuggetsBalance)) {
              currencyItemBalances.nuggets = nuggetsBalance;
            }
            if (!isNil(sapphiresBalance)) {
              currencyItemBalances.sapphires = sapphiresBalance;
            }
            if (!isNil(rubiesBalance)) {
              currencyItemBalances.rubies = rubiesBalance;
            }
            if (!isNil(wchipsBalance)) {
              currencyItemBalances.wchips = wchipsBalance;
            }

            if (!isEmpty(currencyItemBalances)) {
              return Object.assign({}, prev, {
                patronAssets: Object.assign(
                  {},
                  prev.patronAssets,
                  currencyItemBalances
                )
              });
            } else {
              return null;
            }
          }
        });
      }
    })
  }),
  graphql(QUERY_GET_PRIZE_CATEGORIES, {
    name: 'prizeCategoriesData',
    options: props => ({
      fetchPolicy: 'network-only'
    })
  }),
  graphql(QUERY_GET_WSTORE_ITEMS, {
    name: 'wstoreItemsData',
    options: props => ({
      fetchPolicy: 'cache-and-network'
    }),
    props: ({ ownProps, wstoreItemsData }) => ({
      wstoreItemsData,
      subscribeToNewData: () => {
        return wstoreItemsData.subscribeToMore({
          document: SUBSCRIPTION_PURCHASE_UPDATES,
          updateQuery: (prev, { subscriptionData }) => {
            if (subscriptionData.data.itemId !== undefined) {
              const nextData = cloneDeep(prev);
              const wstoreItem = nextData.getWStoreData.items.find(
                subItem => subscriptionData.data.itemId === subItem.itemId
              );
              if (wstoreItem) {
                wstoreItem.wstoreItemCount.availableCount =
                  subscriptionData.data.availableCount;
                if (
                  subscriptionData.data.availableCount <
                  wstoreItem.wstoreItemCount.purchaseLeft
                ) {
                  wstoreItem.wstoreItemCount.purchaseLeft =
                    subscriptionData.data.availableCount;
                }
              }
              return nextData;
            }
          }
        });
      },
      subscribeToPurchaseLeftDataUpdate: () => {
        return wstoreItemsData.subscribeToMore({
          document: SUBSCRIPTION_PURCHASE_LEFT_UPDATES,
          updateQuery: (prev, { subscriptionData }) => {
            if (subscriptionData.data.itemId !== undefined) {
              const nextData = cloneDeep(prev);
              const wstoreItem = nextData.getWStoreData.items.find(
                subItem => subscriptionData.data.itemId === subItem.itemId
              );
              if (wstoreItem) {
                const counts = wstoreItem.wstoreItemCount;
                if (counts.availableCount) {
                  counts.availableCount -=
                    counts.purchaseLeft - subscriptionData.data.purchaseLeft;
                }
                counts.purchaseLeft = subscriptionData.data.purchaseLeft;
              }
              return nextData;
            }
          }
        });
      },
      subscribeToWStoreResetNotificationDataUpdate:
        onWStoreResetNotificationUpdate => {
          return wstoreItemsData.subscribeToMore({
            document: SUBSCRIPTION_WSTORE_RESET_NOTIFICATION,
            updateQuery: (prev, { subscriptionData }) => {
              onWStoreResetNotificationUpdate &&
                onWStoreResetNotificationUpdate();
              return null;
            }
          });
        },
      subscribeToWStoreUserDataUpdate: () => {
        return wstoreItemsData.subscribeToMore({
          document: SUBSCRIPTION_WSTOREUSERDATA_UPDATES,
          updateQuery: (prev, { subscriptionData }) => {
            if (subscriptionData.data.items) {
              const nextData = cloneDeep(prev);
              nextData.getWStoreData.items = subscriptionData.data.items;
              return nextData;
            }
            return null;
          }
        });
      }
    })
  }),
  graphql(QUERY_GET_WSTORE_PROPERTY_SETTINGS, {
    name: 'wstorePropertySettingsData',
    options: props => ({
      fetchPolicy: 'network-only'
    }),
    props: ({ wstorePropertySettingsData }) => ({
      wstorePropertySettingsData,
      subscribeToWStorePropertyUpdateNotificationReloadDataUpdate: () => {
        return wstorePropertySettingsData.subscribeToMore({
          document: SUBSCRIPTION_WSTORE_PROPERTY_UPDATE_NOTIFICATIONS,
          updateQuery: (prev, { subscriptionData }) => {
            if (subscriptionData.data) {
              const nextData = cloneDeep(prev);
              nextData.getWStorePropertySettings.wstorePropertySettings =
                subscriptionData.data.wstorePropertySettings;
              return nextData;
            }
            return null;
          }
        });
      }
    })
  }),
  graphql(QUERY_GET_WSTORE_CONFIGURATION, {
    name: 'wstoreConfigurationData',
    options: props => ({
      fetchPolicy: 'network-only'
    }),
    props: ({ ownProps, wstoreConfigurationData }) => ({
      wstoreConfigurationData,
      subscribeToWStoreAdminUpdateNotificationReloadDataUpdate:
        onWStoreResetNotificationUpdate => {
          return wstoreConfigurationData.subscribeToMore({
            document: SUBSCRIPTION_WSTORE_ADMIN_UPDATE_NOTIFICATION,
            updateQuery: (prev, { subscriptionData }) => {
              if (subscriptionData.data) {
                if (subscriptionData.data.reloadSettings) {
                  onWStoreResetNotificationUpdate();
                }
                const nextData = cloneDeep(prev);
                nextData.getWStoreConfiguration.enabled =
                  subscriptionData.data.enabledWStore;
                return nextData;
              }
              return null;
            }
          });
        }
    })
  }),
  graphql(QUERY_GET_BATTLESLOTS_SUPPORTED_PROPERTIES, {
    name: 'battleSlotsSupportedPropertiesData',
    options: props => ({
      fetchPolicy: 'network-only'
    })
  }),
  graphql(QUERY_GET_BATTLESLOTS_INVENTORY, {
    name: 'battleSlotsInventoryData',
    options: props => ({
      fetchPolicy: 'network-only'
    }),
    props: ({ ownProps, battleSlotsInventoryData }) => ({
      battleSlotsInventoryData,
      subscribeToBattleSlotsInventoryUpdates: () => {
        return battleSlotsInventoryData.subscribeToMore({
          document: SUBSCRIPTION_BATTLE_SLOTS_INVENTORY_UPDATES,
          updateQuery: (prev, { subscriptionData }) => {
            if (
              subscriptionData.data &&
              subscriptionData.data.battleSlotsInventoryCollection
            ) {
              const { inventories } =
                subscriptionData.data.battleSlotsInventoryCollection;
              const nextData = cloneDeep(prev);
              nextData.getBattleSlotsInventory = inventories;
              return nextData;
            }
            return null;
          }
        });
      }
    })
  }),
  graphql(QUERY_GET_BATTLESLOTS_INFORMATION_AS_MARKDOWN, {
    name: 'battleSlotsInformationMarkdownTextData'
  }),
  graphql(MUTATION_MAKE_WSTORE_PURCHASE, {
    props: ({ ownProps, mutate }) => ({
      makeWstoreItemPurchase: (purchaseItem, exchange) =>
        mutate({
          variables: {
            input: {
              itemId: purchaseItem.itemId,
              wscore: purchaseItem.wscore,
              itemCosts: {
                wscore: purchaseItem.wscore,
                nuggets: purchaseItem.nuggetCost,
                sapphires: purchaseItem.sapphireCost,
                rubies: purchaseItem.rubyCost,
                wchips: purchaseItem.wchipCost
              },
              exchange
            }
          },
          update: (store, resp) => {
            if (resp.data.wstoreItemPurchase.success) {
              const prevData = store.readQuery({
                query: QUERY_GET_WSTORE_ITEMS
              });
              const nextData = cloneDeep(prevData);
              const wstoreItem = nextData.getWStoreData.items.find(
                item => item.itemId === purchaseItem.itemId
              );

              if (wstoreItem && isQuest(wstoreItem)) {
                wstoreItem.prizeData.questAwardData.isActive = true;

                wstoreItem.prizeData.questAwardData.awardCount =
                  wstoreItem.prizeData.questAwardData.awardCount + 1;

                const sameQuests = nextData.getWStoreData.items.filter(item =>
                  item.prizeData && item.prizeData.questAwardData
                    ? item.prizeData.questAwardData.quest.id ===
                        wstoreItem.prizeData.questAwardData.quest.id &&
                      item.itemId !== purchaseItem.itemId
                    : false
                );

                sameQuests.forEach(
                  item => (item.prizeData.questAwardData.isActive = true)
                );

                store.writeQuery({
                  query: QUERY_GET_WSTORE_ITEMS,
                  data: nextData
                });
              } else if (
                wstoreItem &&
                resp.data.wstoreItemPurchase.purchaseLeft !== undefined
              ) {
                wstoreItem.wstoreItemCount.purchaseLeft =
                  resp.data.wstoreItemPurchase.purchaseLeft;
                store.writeQuery({
                  query: QUERY_GET_WSTORE_ITEMS,
                  data: nextData
                });
              }
            }
          }
        })
    })
  }),
  graphql(CHANGE_PREFERRED_LOCATION_MUTATION, {
    props: ({ ownProps, mutate }) => ({
      changePreferredLocation: location =>
        mutate({
          variables: { input: { preferredLocation: location } }
        })
    })
  }),
  graphql(QUERY_GET_EXCHANGE_RATES, {
    name: 'exchangeRatesData',
    options: props => ({
      fetchPolicy: 'network-only'
    })
  }),
  graphql(QUERY_GET_REMOTE_CONFIG_ENTRY, {
    name: 'newWStoreEnabledData',
    options: {
      variables: {
        key: CV_WEB_NEW_WSTORE_UI_ENABLED
      },
      fetchPolicy: 'cache-and-network'
    },
    props: ({ ownProps, newWStoreEnabledData }) => {
      return {
        newWStoreEnabledData,
        subscribeToNewData: () => {
          return newWStoreEnabledData.subscribeToMore({
            document: REMOTE_CONFIG_EVENT,
            updateQuery: (prev, { subscriptionData }) => {
              if (subscriptionData?.data?.action === 'Update') {
                subscriptionData?.data?.entries.forEach(({ key, value }) => {
                  if (key === CV_WEB_NEW_WSTORE_UI_ENABLED) {
                    prev.remoteConfigEntry.value = value;
                  }
                });
              }
              return prev;
            }
          });
        }
      };
    }
  }),
  graphql(QUERY_GET_REMOTE_CONFIG_ENTRY, {
    name: 'chicagoWstore',
    options: {
      variables: {
        key: WSTORE_CHICAGO_WSTORE_AVAILABLE
      },
      fetchPolicy: 'cache-and-network'
    },
    props: ({ ownProps, chicagoWstore }) => {
      return {
        chicagoWstore,
        subscribeToNewData: () => {
          return chicagoWstore.subscribeToMore({
            document: REMOTE_CONFIG_EVENT,
            updateQuery: (prev, { subscriptionData }) => {
              if (subscriptionData?.data?.action === 'Update') {
                subscriptionData.data.entries.forEach(({ key, value }) => {
                  if (key === WSTORE_CHICAGO_WSTORE_AVAILABLE) {
                    prev.remoteConfigEntry.value = value;
                  }
                });
              }
              return prev;
            }
          });
        }
      };
    }
  })
)(WStoreContainer);
